import InstagramTaggedProductQuery from "@apps/instagram/queries/InstagramTaggedProductQuery";
import InstagramTaggedProductService from "@apps/instagram/services/InstagramTaggedProductService";
import TikTokGalleryQuery from "@apps/tiktok/queries/TikTokGalleryQuery";
import { TikTokPostsQuery } from "@apps/tiktok/queries/TikTokPostQuery";
import TikTokGalleryService from "@apps/tiktok/services/TikTokGalleryService";
import { TikTokPostsService } from "@apps/tiktok/services/TikTokPostsService";
import { InjectionKey } from "@lib/svelte-typed-context";
import { CartQuery } from "@modules/cart/queries/CartQuery";
import { CartService } from "@modules/cart/services/CartService";
import CartAvailabilityProvider from "@modules/common_module/CartAvailabilityProvider/CartAvailabilityProvider";
import LocationControllerInterface from "@modules/common_module/LocationController/LocationControllerInterface";
import { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import { ProductsService } from "@modules/products/services/ProductsService";

export const tikTokGalleryWidgetContextToken: InjectionKey<{
    cartService: CartService;
    cartQuery: CartQuery;

    tikTokGalleryService: TikTokGalleryService;
    tikTokGalleryQuery: TikTokGalleryQuery;

    tiktokPostsService: TikTokPostsService;
    tiktokPostsQuery: TikTokPostsQuery;

    taggedProductService: InstagramTaggedProductService;
    taggedProductQuery: InstagramTaggedProductQuery;

    productsQuery: ProductsQuery;
    productsService: ProductsService;

    locationController: LocationControllerInterface;

    cartAvailabilityProvider: CartAvailabilityProvider;
}> = Symbol("tikTokGalleryWidgetToken");
